'use strict';
/**
 * 所有图层的基类
 * @module BaseLayer
 */
define([
    '../base/Class',
    '../utils/CommonUtil',
    '../utils/RenderUtil',
    '../misc/AppEvent',
    '../g2'
],function(
    Class,
    CommonUtil,
    RenderUtil,
    AppEvent,
    g2
){
    /**
     * 构造方法
     * @constructor
     * @classdesc 图层基类
     * @augments G.base.Class
     * @alias G.lys.BaseLayer
     * @param {Object} options - 必填，构造参数；
     * @param {G.Map/g2.carto.Map} options.map -必填，地图对象
     * @param {String} options.layerId - 可选，图层id，默认为随机字符串
     * @param {Number} options.spatialReference - 可选，图层坐标系，默认map的坐标系
     * @param {Number} options.dataSpatialReference - 可选，叠加数据的坐标系，默认map的坐标系
     * @param {Function} options.symbolUpdateCallback - 可选，地图显示的符号更新时的回调，
     * @param {Object} options.callbackContext - 可选，回调的上下文
     * @returns {Class} - 实例化的对象
     */
    var layer=Class.extend({
        options:{
            id:null,
            name:null,
            /***
             * 地图的坐标系
             */
            spatialReference: null,
            /***
             * 数据的坐标系
             */
            dataSpatialReference: null,
            /***
             * 图层当前显示的符号改变的回调；
             * 包括：
             * 添加移除要素；切换显隐；更新符号等操作；
             */
            symbolUpdateCallback:function(data){
            },
            /***
             * 回调的上下文
             */
            callbackContext:window
        },
        includes:AppEvent.prototype,
        initialize:function(options){
            Class.setOptions(this,options);
            //
            this.map=this.options.map;
            /**
             * 2018年1月30日19:32:00
             * 兼容传递id layerId name layerName的形式
             * @type {null}
             */
            this.options.layerId=this.options.layerId||this.options.id;
            this.options.layerName=this.options.layerName||this.options.name;
            //存储图层id
            this.id=this.options.layerId;
            this.name=this.options.layerName;
            //图层的坐标系、数据的坐标系
            this.options.spatialReference=this.map.spatialReference;
            this.options.dataSpatialReference=this.options.dataSpatialReference
                ||this.options.spatialReference;
            //转换坐标系
            this.projService=new g2.sfs.CoordinateTransform({});
            //是否更新符号的时候调用回调
            this._invokeSymbolUpdateCallback=true;
            //当前数据范围[minx,miny,maxx,maxy]
            this._currentExtent=[NaN,NaN,NaN,NaN];
            //
            this._addListeners();
        },
        /**
         * 添加监听
         * @method
         * @private
         */
        _addListeners:function(){
        },
        /**
         * 移除监听
         * @method
         * @private
         */
        _removeListeners:function(){
        },
        /**
         * @method
         * 符号改变时调用的方法
         * @private
         */
        _onSymbolsUpdated:function(){},
        /**
         * 销毁
         * @method
         */
        destroy:function(){
            try{
                this._removeListeners();
            }catch(e){}

        }
    });
    layer.include({
        /**
         * 获取要素
         * @method
         * @memberOf G.lys.BaseLayer.prototype
         */
        getElements:function(){
        },
        /**
         * 根据id获取元素
         * @method
         * @memberOf G.lys.BaseLayer.prototype
         * @param {String} eleId - 必填，元素的id
         * @returns {Object}
         */
        getElementById:function(eleId){},
        /**
         * 清空图层
         * @method
         * @memberOf G.lys.BaseLayer.prototype
         */
        clear:function(){},
        /**
         * 获取ts-gis图层对象
         * @method
         * @memberOf G.lys.BaseLayer.prototype
         * @returns {g2.lys.Layer}
         */
        getLayer:function(){},
        /**
         * 获取图层对象id
         * @method
         * @memberOf G.lys.BaseLayer.prototype
         * @returns {String}
         */
        getLayerId:function(){},
        /**
         * 控制显影
         * @method
         * @memberOf G.lys.BaseLayer.prototype
         * @param {boolean} visible - 显示隐藏
         */
        setVisible:function(visible){},
        /**
         * 获取显影
         * @method
         * @memberOf G.lys.BaseLayer.prototype
         * @returns {Boolean}
         */
        getVisible:function(){},

        /**
         * 设置层级
         * @method
         * @memberOf G.lys.BaseLayer.prototype
         * @param zIndex {Number}  图层顺序值
         */
        setZIndex:function(zIndex){
            return this.getLayer().setZIndex(zIndex);
        },

        /**
         * 获取层级
         * @method
         * @memberOf G.lys.BaseLayer.prototype
         * @returns {Number} 图层顺序值
         */
        getZIndex:function(){
            return this.getLayer().getZIndex();
        },
        /**
         * 获取图层对象名称
         * @method
         * @memberOf G.lys.BaseLayer.prototype
         * @returns {String}
         */
        getLayerName:function(){},
        /**
         * 点击选中
         * @method
         * @memberOf G.lys.BaseLayer.prototype
         * @param {Number} screenX - 鼠标屏幕x坐标
         * @param {Number} sreenY - 鼠标屏幕y坐标
         * @returns {Object} - 返回选中的元素
         */
        hitTest:function(screenX, sreenY){},
        /**
         * 获取当前图层的数据范围
         * @method
         * @memberOf G.lys.BaseLayer.prototype
         * @returns {Array} - [minx,miny,maxx,maxy]
         */
        getLayerExtent:function(){
            return this._currentExtent;
        },
        /**
         * 切换更新符号时调用回调的开关
         * @method
         * @memberOf G.lys.BaseLayer.prototype
         * @param {Boolean} enabled - true打开 false关闭；
         */
        toggleInvokeSymbolUpdateCallback:function(enabled){
            if(typeof enabled=='boolean'){

            }else{
                enabled=!this._invokeSymbolUpdateCallback;
            }
            this._invokeSymbolUpdateCallback=enabled;
        }
    });
    /**
     * common functions
     */
    layer.include({
        /**
         * 根据配置获取颜色
         * @method
         * @param data
         * @private
         */
        _getColor:function(data){
            return RenderUtil._getColor(data);
        },
        /**
         * jstsGeom转envelope
         * @method
         * @param jstsGeom
         * @returns {Object}
         * @private
         */
        _envelopeFromGeom:function(jstsGeom){
            try{
                var array=jstsGeom.shell.points,
                    minx,miny,maxx,maxy;
                minx=miny=10000000;
                maxx=maxy=-10000000;
                for(var k=0,len=array.length;k<len;k++){
                    var point=array[k];
                    minx=Math.min(minx,point.x);
                    miny=Math.min(miny,point.y);
                    maxx=Math.max(maxx,point.x);
                    maxy=Math.max(maxy,point.y);
                }
                return [minx,miny,maxx,maxy];
            }catch(e){
                return [NaN,NaN,NaN,NaN];
            }
        },
        /**
         * 调用回调
         * @method
         * @memberOf G.lys.BaseLayer.prototype
         * @param {Function} fn - 回调的名称或者对象
         * @param {Object|String} data - 回调的数据
         */
        invokeCallback:function(fn,data){
            var context=this.options.callbackContext||window;
            if(typeof fn=='string'){
                fn=this.options[fn];
            }
            if(CommonUtil.isFunction(fn)){
                fn.call(context,data);
            }
        }
    });

    return layer;
});
